/* Sustainability Projects & Initiatives — hero CTA that sits in the top
   button cluster, directly below the Live Cleanliness / Labor monitors.
   Opens a "coming soon" panel for now; the full module (initiatives with
   status + progress) is planned. */
import { useState } from 'react';
import { Leaf, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

export default function SustainabilityButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid="hero-sustainability-cta"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 px-7 py-3 rounded-full text-white font-bold text-sm tracking-wide transition-all hover:-translate-y-0.5"
        style={{
          fontFamily: 'Manrope, sans-serif',
          background: 'linear-gradient(135deg, #15803D 0%, #166534 55%, #0A1A2F 100%)',
          border: '1px solid rgba(163,212,163,0.35)',
        }}
        title="Sustainability Projects & Initiatives"
      >
        <Leaf className="w-4 h-4" /> Sustainability Projects and Initiatives
      </button>

      <Dialog open={open} onOpenChange={(v) => !v && setOpen(false)}>
        <DialogContent className="max-w-md w-[95vw]" data-testid="sustainability-dialog">
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
            <Leaf className="w-5 h-5 text-green-700" />
            Sustainability Projects and Initiatives
          </DialogTitle>
          <DialogDescription>
            Track the property&apos;s sustainability projects and initiatives — energy, water, waste and community programmes — with status and progress.
          </DialogDescription>
          <div className="mt-4 flex flex-col items-center text-center gap-2 py-6" data-testid="sustainability-coming-soon">
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ backgroundColor: 'rgba(21,128,61,0.10)' }}>
              <Sparkles className="w-7 h-7 text-green-700" />
            </div>
            <p className="text-base font-bold text-gray-900">Coming soon</p>
            <p className="text-sm text-gray-500 max-w-xs">
              This module is on the way. You&apos;ll be able to add and manage sustainability initiatives here.
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
